import type { Language } from '@/api/v1/administration/profile/update-language/update-language.types'
import type { Locale } from '@/stores/language'

const LOCALE_TO_LANGUAGE: Record<Locale, Language> = {
  ptBr: 'PtBr',
  enUs: 'EnUs',
  esEs: 'EsEs',
  frFr: 'FrFr',
  deDe: 'DeDe',
  itIt: 'ItIt',
}

export const localeToLanguage = (locale: Locale): Language =>
  LOCALE_TO_LANGUAGE[locale]
